import React, { useEffect, useState } from "react";
import { Typography, Grid, Hidden, Button } from "@material-ui/core";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { history } from "../../../../helpers";
import { routePaths } from "../../../config/route-paths";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { Skeleton } from "@material-ui/lab";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) =>
  createStyles({
    detailsBtn: {
      color: theme.palette.ePrimary.base,
      textTransform: "lowercase !important",
    },
    subtitleColor: {
      color: theme.palette.eRich.base,
    },
    backButton: {
      color: theme.palette.ePrimary.base,
    }
  })
);

export default function QuickPayHeader({ data }) {
  let classes = useStyles();
  // let labels = useSelector(
  //   (store) => store?.labels?.data?.getLabels?.E_QUICK_PAY
  // );
  const {t:labels,ready:labelsReady}=useTranslation("label-E_QUICK_PAY")
  const [open, setOpen] = useState(false);
  const handleClicked = () => {
    setOpen(!open);
  };
  const backCall = () => {
    history.push(routePaths.QUICK_PAY);
  };

  return (
    <>
      <Hidden xsDown>
        <Grid container spacing={1} direction="column" alignItems="left">
          <Grid item xs={12} md={3} align="left">
            <Button
              size="small"
              startIcon={<ArrowBackIosIcon fontSize="small" />}
              onClick={backCall}
              className={classes.backButton}
            >
              <b>{labels("E_QUICK_PAY_BACK_BUTTON")}</b>
            </Button>
          </Grid>
          <Grid item xs={12} md={6} align="left">
            <Typography
              variant="h5"
              className={classes.backButton}
            >
              {labels("E_QUICK_PAY_TITLE") ? (
                <b> {labels("E_QUICK_PAY_TITLE")}</b>
              ) : (
                <Skeleton variant="rectangular" animation="wave" />
              )}

            </Typography>
          </Grid>
          <Grid item align="left">
            {
              data ? (
                <Typography
                  variant="subtitle2"
                  className={classes.subtitleColor}
                  dangerouslySetInnerHTML={{
                    __html: data("E_QUICK_PAY_SUBTITLE").answer,
                  }}
                />
              ) : (
                <Skeleton variant="rectangular" animation="wave" />
              )
            }
          </Grid>
        </Grid>

      </Hidden>
      <Hidden smUp>
        <Grid container spacing={1} justify="flex-start" direction="row">
          <Grid item xs={12} md={3}>
            <Button
              className={classes.backButton}
              startIcon={<ArrowBackIosIcon fontSize="small" />}
              onClick={backCall}
            >
             <b>{labels("E_QUICK_PAY_BACK_BUTTON")}</b>
            </Button>
          </Grid>
          <Grid item xs={12} md={6}>
            <Grid container spacing={1}>
              <Grid item>
                <Typography
                  variant="h5"
                  className={classes.backButton}
                >
                 <b> {labels("E_QUICK_PAY_TITLE")}</b>
                </Typography>
              </Grid>
              <Grid item>
                <Button variant="text" className={classes.detailsBtn} onClick={handleClicked}>
                  {open ? (
                    <Typography>
                      {labels("E_QUICK_PAY_HIDE")} <ExpandLess />
                    </Typography>
                  ) : (
                    <Typography>
                      {labels("E_QUICK_PAY_DETAILS")} <ExpandMore />
                    </Typography>
                  )}
                </Button>
              </Grid>
            </Grid>
            {open && (
              <Typography
              variant="subtitle2" 
              className={classes.subtitleColor}
                dangerouslySetInnerHTML={{
                  __html: data("E_QUICK_PAY_SUBTITLE").answer,
                }}
              />
            )}
          </Grid>
        </Grid>
      </Hidden>
    </>
  );
}
